export default "__VITE_ASSET__d47e9df9__"